// utils.tsx

interface SubMenuItem {
  title_en: string;
  key?: number;
  keywords: string;
  url: string;
}

interface Search {
  name: string;
  key: any;
  keywords: string;
  url: string;
}

interface MenuItem {
  id: number;
  menu: number;
  order: number;
  color: string;
  icon_name: string;
  title_en: string;
  title_bn: string;
  action: string;
  url: string;
  is_active: boolean;
  is_popular: boolean;
  sub_menu_items: SubMenuItem[];
}

export interface MenuProps {
  count: number;
  next?: null;
  previous?: null;
  results: MenuItem[];
}

// Utility function to convert Search to SubMenuItem
function convertToSubMenuItem(searchItem: Search): SubMenuItem {
  return {
    title_en: searchItem.name,
    keywords: searchItem.keywords,
    url: searchItem.url,
  };
}

export function extractSubMenuItems(
  data: MenuProps | undefined
): SubMenuItem[] {
  const subMenuItemsList: SubMenuItem[] = [];
  let keyCounter = 1;

  if (data && Array.isArray(data)) {
    data.forEach((result) => {
      if (result.sub_menu_items && Array.isArray(result.sub_menu_items)) {
        result.sub_menu_items.forEach((subMenuItem: any) => {
          const itemInfo: Search = {
            name: subMenuItem.title_en || '',
            keywords: subMenuItem.keywords || '',
            key: keyCounter,
            url: subMenuItem.url || '',
          };
          subMenuItemsList.push(convertToSubMenuItem(itemInfo));
          // eslint-disable-next-line no-plusplus
          keyCounter++;
        });
      }
    });
  }
  subMenuItemsList.push({
    title_en: 'Important contacts',
    keywords:
      '{Lv]$ldw>U]t2fy, numbers , phone, call, emergency, emergency contact, important, blc, bdc, sexual harassment, it support, it helpdesk, help',
    url: '',
  });
  subMenuItemsList.push({
    title_en: 'Feedback',
    keywords:
      '{Lv]$ldw>U]t3fy, Feedback, feedback, opinion, result, positive, negative, happiness, rating, mybrac, rate',
    url: '',
  });
  return subMenuItemsList;
}

const filterSearch = (arr: any[], searchKey: string) => {
  return arr?.filter((obj: any) => {
    return Object.keys(obj)?.some((key) => {
      if (key === 'url') {
        return false;
      }

      return obj[key]?.toLowerCase()?.includes(searchKey.toLowerCase());
    });
  });
};

export const userFilterSearch = (arr: any[], searchKey: string) => {
  return arr?.filter((obj: any) => {
    return Object.keys(obj)?.some((key) => {
      // if (key === 'url') {
      //   return false;
      // }

      return obj[key]?.toLowerCase()?.includes(searchKey.toLowerCase());
    });
  });
};

export default filterSearch;
